"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider as NextThemesProvider } from "next-themes";
export default function ThemeProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <NextThemesProvider attribute="class" defaultTheme="system" enableSystem={true}>{children}</NextThemesProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}